<template>
  <div class="verificar-wrap">
    <div class="verificar-card">
      <img src="@/assets/img/quanty.png" class="verificar-logo" alt="Quanty" />

      <div v-if="estado === 'cargando'" class="verificar-estado">
        <div class="spinner-border" role="status"></div>
        <p class="mt-3">Verificando tu cuenta…</p>
      </div>

      <div v-if="estado === 'ok'" class="verificar-estado">
        <div class="verificar-icono verificar-icono--ok">✓</div>
        <h5 class="verificar-titulo">¡Cuenta activada!</h5>
        <p class="verificar-desc">
          Tu cuenta está activa. Ya puedes iniciar sesión y comprar tu suscripción.
        </p>
        <button class="btn-volver" @click="$store.commit('abrirLoginModal')">
          Iniciar sesión
        </button>
      </div>

      <div v-if="estado === 'error'" class="verificar-estado">
        <div class="verificar-icono verificar-icono--error">✕</div>
        <h5 class="verificar-titulo">Enlace no válido</h5>
        <p class="verificar-desc">
          {{ mensajeError }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerificarEmail",
  props: ["token"],

  data() {
    return {
      estado: "cargando",
      mensajeError: "El enlace de verificación no es válido o ya fue utilizado.",
    };
  },

  beforeMount() {
    this.$store.commit('setShowSidenav', false);
    this.$store.commit('setShowNavbar', true);
    this.$store.commit('setShowFooter', true);
  },

  async mounted() {
    try {
      const resp = await this.$store.dispatch("auth/activarCuentaEmail", this.token);
      if (resp?.res === "OK") {
        this.estado = "ok";
      } else {
        this.mensajeError = resp?.mensaje || this.mensajeError;
        this.estado = "error";
      }
    } catch (err) {
      const msg = err?.response?.data?.mensaje || err?.response?.data?.message;
      if (msg) this.mensajeError = msg;
      this.estado = "error";
    }
  },
};
</script>

<style scoped>
.verificar-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--q-bg, #0e203d);
  padding: 2rem 1rem;
}

.verificar-card {
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 16px;
  padding: 2.5rem 2rem;
  max-width: 420px;
  width: 100%;
  text-align: center;
}

.verificar-logo {
  max-width: 160px;
  margin-bottom: 2rem;
}

.verificar-estado {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.verificar-icono {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 900;
  margin-bottom: 1rem;
}

.verificar-icono--ok {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.verificar-icono--error {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.verificar-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--q-text);
  margin-bottom: 0.75rem;
}

.verificar-desc {
  font-size: 0.9rem;
  color: var(--q-muted);
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.btn-volver {
  padding: 10px 28px;
  background: var(--q-gold);
  color: var(--q-gold-on, #0e203d);
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
}

.btn-volver:hover { opacity: 0.85; }
</style>
